
const Resources = () =>{
    return(
        <>
        Resources
        </>
    )
} 

export default Resources